@charset "UTF-8";

/* src/app/components/controls/sem-translation-pills/sem-translation-pills.component.scss */
:host {
  display: block;
}
.sem-translation-pills {
  display: block;
  margin: 6px 0 0;
  position: relative;
  z-index: 100;
  font-family: Inter, sans-serif;
}
.sem-translation-pills:has(.sem-translation-popover) {
  z-index: 1200;
}
.sem-translation-pills-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.sem-translation-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  height: 28px;
  max-width: 300px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.sem-translation-code {
  flex: 0 0 auto;
  min-width: 0;
  padding: 0;
  background: none;
  border-radius: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1;
  color: #94a3b8;
}
.sem-translation-preview {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  line-height: 1.25;
  color: #0f172a;
}
.sem-translation-pill.filled {
  background: #fff;
  border-color: #cbd5e1;
}
.sem-translation-pill.filled .sem-translation-code {
  color: #64748b;
}
.sem-translation-pill:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}
.sem-translation-pill.filled:hover {
  background: #f8fafc;
}
.sem-translation-pill.is-open,
.sem-translation-pill:focus-visible {
  outline: none;
  border-color: var(--wg-accent-300, #93c5fd);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--wg-accent, #3b82f6) 10%, transparent);
}
.sem-translation-pill.is-open {
  background: var(--wg-accent-50, #eff6ff);
}
.sem-translation-pill.is-open .sem-translation-code {
  color: var(--wg-accent-800, #1e40af);
}
.sem-translation-pill.is-open .sem-translation-preview {
  color: #1e3a8a;
}
.sem-translation-pill.filled:not(.is-open)[data-lang=en] .sem-translation-code {
  color: #a13c34;
}
.sem-translation-pill.filled:not(.is-open)[data-lang=hr] .sem-translation-code {
  color: #2f6fb0;
}
.sem-translation-pill.filled:not(.is-open)[data-lang=de] .sem-translation-code {
  color: #1f7a5a;
}
.sem-translation-pill.filled:not(.is-open)[data-lang=it] .sem-translation-code {
  color: #6b4ea8;
}
.sem-translation-globe {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  opacity: 1;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;
}
.sem-translation-globe .material-symbols-outlined {
  font-size: 16px;
  line-height: 1;
}
.sem-translation-globe:hover {
  background: #f1f5f9;
  color: #64748b;
}
.sem-translation-globe.on {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #64748b;
}
.sem-translation-globe:focus-visible {
  outline: none;
  border-color: var(--wg-accent-300, #93c5fd);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--wg-accent, #3b82f6) 10%, transparent);
}
.sem-translation-popover {
  position: absolute;
  top: 34px;
  left: 0;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 340px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
  padding: 12px;
  font-family: Inter, sans-serif;
}
.sem-translation-popover.flip-up {
  top: auto;
  bottom: 34px;
}
.sem-translation-popover-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 2px;
}
.sem-translation-popover-lang {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  color: #0f172a;
}
.sem-translation-popover-field {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1;
  color: #64748b;
}
.sem-translation-source {
  display: flex;
  align-items: baseline;
  gap: 8px;
  max-width: 460px;
  padding: 7px 10px;
  border-left: 3px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 6px 6px 0;
  font-size: 13px;
  line-height: 1.35;
  color: #64748b;
}
.sem-translation-source > span:not(.sem-translation-source-tag) {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sem-translation-source-tag {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1;
  color: #94a3b8;
}
.sem-translation-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sem-translation-input {
  flex: 1 1 auto;
  min-width: 280px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  font-family: Inter, sans-serif;
  font-size: 13px;
  color: #0f172a;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.sem-translation-input::placeholder {
  color: #94a3b8;
}
.sem-translation-input:focus {
  outline: none;
  border-color: var(--wg-accent-300, #93c5fd);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--wg-accent, #3b82f6) 10%, transparent);
}
.sem-translation-input:disabled {
  background: #f8fafc;
  color: #0f172a;
  -webkit-text-fill-color: #0f172a;
}
.sem-translation-popover.multiline {
  min-width: 460px;
}
.sem-translation-textarea {
  height: auto;
  min-height: 104px;
  padding: 8px 10px;
  resize: vertical;
  line-height: 1.45;
  white-space: pre-wrap;
}
.sem-translation-popover.multiline .sem-translation-source {
  max-width: none;
  white-space: pre-wrap;
  max-height: 5.8em;
  overflow: auto;
}
.sem-translation-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.sem-translation-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  font-family: Inter, sans-serif;
  font-size: 12px;
  color: #475569;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}
.sem-translation-action .material-symbols-outlined {
  font-size: 15px;
  line-height: 1;
}
.sem-translation-action:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}
.sem-translation-action:disabled {
  opacity: 0.6;
  cursor: default;
}
.sem-translation-action.suggest:hover {
  color: var(--wg-accent-800, #1e40af);
}
.sem-translation-action.remove:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}
.sem-translation-action:focus-visible {
  outline: none;
  border-color: var(--wg-accent-300, #93c5fd);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--wg-accent, #3b82f6) 10%, transparent);
}
.sem-translation-commit-pair {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex: 0 0 auto;
}
.sem-translation-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}
.sem-translation-icon .material-symbols-outlined {
  font-size: 18px;
  line-height: 1;
}
.sem-translation-icon.confirm {
  color: #16a34a;
}
.sem-translation-icon.confirm:hover {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
}
.sem-translation-icon.cancel {
  color: #b91c1c;
}
.sem-translation-icon.cancel:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}
.sem-translation-icon:focus-visible {
  outline: none;
  border-color: var(--wg-accent-300, #93c5fd);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--wg-accent, #3b82f6) 10%, transparent);
}
.sem-translation-pill.pending-removal {
  background: #fef2f2;
  border-style: dashed;
  border-color: #fecaca;
}
.sem-translation-pill.pending-removal .sem-translation-code,
.sem-translation-pill.pending-removal .sem-translation-preview {
  color: #b91c1c;
  text-decoration: line-through;
  text-decoration-color: #fca5a5;
}
.sem-translation-pill.pending-removal:hover {
  background: #fee2e2;
  border-color: #fca5a5;
}
.sem-translation-undo {
  flex: 0 0 auto;
  font-size: 14px;
  line-height: 1;
  color: #b91c1c;
}
.sem-translation-source.empty {
  background: #fffbeb;
  border-color: #fde68a;
}
.sem-translation-source.empty .sem-translation-source-tag {
  color: #b45309;
}
.sem-translation-source-missing {
  font-style: italic;
  color: #b45309;
}
.sem-translation-meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-size: 11px;
  line-height: 1;
  color: #94a3b8;
}
.sem-translation-hint {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sem-translation-counter {
  flex: 0 0 auto;
  font-variant-numeric: tabular-nums;
}
.sem-translation-counter.at-limit {
  color: #b91c1c;
  font-weight: 700;
}
/*# sourceMappingURL=sem-translation-pills.component.css.map */
